import { useTheme } from "@/lib/theme";
import { useSettings } from "@/lib/settings";

/**
 * Logo — if admin uploaded a custom logo, we render it inside a dark rounded pill
 * so light text on the logo stays visible on both light & dark theme headers.
 */
export default function Logo({ size = 32, showText = true, className = "", darkBackdrop = true }) {
  const { theme } = useTheme();
  const { settings } = useSettings();
  const textColor = theme === "dark" ? "#F8FAFC" : "#0F172A";

  if (settings?.logo_url) {
    const h = Math.round(size * 1.6);
    const inner = <img src={settings.logo_url} alt="Eagle Eye" style={{ height: h, width: "auto" }} className="object-contain block" />;
    return (
      <div className={`flex items-center ${className}`} data-testid="brand-logo">
        {darkBackdrop ? (
          <div className="rounded-xl px-3 py-1.5 bg-eagle-ink shadow-sm border border-white/5">
            {inner}
          </div>
        ) : inner}
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <svg viewBox="0 0 100 60" height={size} width={size * 1.67} xmlns="http://www.w3.org/2000/svg" aria-label="Eagle Eye">
        <g fill="#FFB703">
          <path d="M2 22 L38 20 L44 26 L20 32 Z" />
          <path d="M6 30 L36 30 L40 36 L16 40 Z" />
          <path d="M98 22 L62 20 L56 26 L80 32 Z" />
          <path d="M94 30 L64 30 L60 36 L84 40 Z" />
          <path d="M46 8 L54 8 L58 16 L50 22 L42 16 Z" />
          <path d="M50 4 L52 12 L48 12 Z" fill="#0A0A0A" opacity="0.4" />
        </g>
        <rect x="42" y="30" width="16" height="10" fill="#9CA3AF" rx="1" />
        <rect x="44" y="40" width="12" height="4" fill="#6B7280" />
        <circle cx="50" cy="50" r="8" fill="#D1D5DB" />
        <circle cx="50" cy="50" r="5" fill="#111827" />
        <circle cx="50" cy="50" r="1.6" fill="#FFB703" />
      </svg>
      {showText && (
        <div className="leading-none">
          <div className="font-display font-black tracking-tight text-lg" style={{ color: textColor }}>EAGLE EYE</div>
          <div className="text-[9px] tracking-[0.22em] uppercase text-muted-foreground -mt-0.5">Alarm · Monitoring · Security</div>
        </div>
      )}
    </div>
  );
}
